export default __webpack_public_path__ + "static/media/alien-gen.349198bb.jpg";